import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_clipboard = _resolveDirective("clipboard")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
    text: "",
    type: "primary",
    icon: _ctx.CopyDocument
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["icon"])), [
    [_directive_clipboard, _ctx.text]
  ])
}